import React from 'react'
import cl from 'classnames'

import { MarqueeProps, Types } from './types'

import styles from './styles.module.scss'

const Marquee: React.FC<MarqueeProps> = ({
	type,
	component,
	countElement = 3,
	wrapperClassName
}) => {
	const items = new Array(countElement).fill(component)

	return (
		<div
			className={cl(styles.marquee, wrapperClassName, {
				[styles.default]: type === Types.default,
				[styles.warning]: type === Types.warning,
				[styles.error]: type === Types.error
			})}
		>
			<div className={styles.line} children={items} />
			<div className={styles.line} children={items} />
		</div>
	)
}

export default Marquee
